<form [formGroup]="passwordForm" (ngSubmit)="goToSendOTP()">
  <citadel-form-section>
    <div class="header-strip mx-32 mt-32 mb-16">
      <div class="formHeader">Enter your password</div>
    </div>

    <citadel-form-element heading="Password" class="mx-32">
      <citadel-input type="password" CitadelFormControlStyle="squared" isPasswordVisible="true" autocomplete="current-password"
        [formControlName]="'password'" *citadelValidate="passwordForm.controls['password']"
        placeholder="Enter password" />
    </citadel-form-element>
    @if (passwordFormSubmitted && pswForm.password.invalid  &&  pswForm.password.errors.required) {
      <div
        class="invalid-feedback mx-32">
        <small>Password is required</small>
      </div>
    }
    <div class="mx-32 mt-24 mb-32">
      <citadel-button [isSubmit]="true" buttonStyle="primary" (click)="goToSendOTP()" [heading]="'Next: One-time-PIN'"
      [icon]="{right:'chevron-right'}" buttonSize="large" />
    </div>
    <div class="mx-32 mb-32">
      <a (click)="beforeValidateEmail()" class="teal cursor-pointer">Forgot your password?</a>
    </div>
  </citadel-form-section>
</form>
